// extracted by mini-css-extract-plugin
export default {"md-preview":"styles_md-preview__4tTyD","text":"styles_text__Wu0r3"};